import React, { useState, useEffect } from 'react';
import './ResponsiveOverlay.scss';

const ResponsiveOverlay: React.FC = () => {
    const [showOverlay, setShowOverlay] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setShowOverlay(window.innerWidth < 1000);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    if (!showOverlay) return null;

    return (
        <div className="responsive-overlay">
            <div className="responsive-overlay__content">
                <h2>Screen Size Not Supported</h2>
                <p>
                    Please resize or use a device with a larger screen to access
                    this application.
                </p>
            </div>
        </div>
    );
};

export default ResponsiveOverlay;
